/* PawPocket theme helpers: rotating quote card and scroll carousels. */
(() => {
  const buildDots = (root, count, onPick) => {
    const dots = root.querySelector('[data-dots]');
    if (!dots || count < 2) return () => {};
    dots.innerHTML = '';
    const buttons = Array.from({ length: count }, (_, i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'pp-dots__dot';
      b.setAttribute('aria-label', `Go to slide ${i + 1}`);
      b.addEventListener('click', () => onPick(i));
      dots.appendChild(b);
      return b;
    });
    return (active) => buttons.forEach((b, i) => b.setAttribute('aria-current', i === active ? 'true' : 'false'));
  };

  class PPRotator extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      if (this.slides.length < 2) return;
      this.index = 0;
      this.mark = buildDots(this, this.slides.length, (i) => this.show(i, true));
      this.show(0);
      const secs = parseInt(this.dataset.interval || '0', 10);
      if (secs > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.timer = setInterval(() => this.show((this.index + 1) % this.slides.length), secs * 1000);
        this.addEventListener('mouseenter', () => clearInterval(this.timer), { once: true });
      }
    }
    disconnectedCallback() { clearInterval(this.timer); }
    show(i, user) {
      if (user) clearInterval(this.timer);
      this.index = i;
      this.slides.forEach((s, n) => s.classList.toggle('is-active', n === i));
      this.mark(i);
    }
  }

  class PPCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      if (!this.track) return;
      this.slides = Array.from(this.track.querySelectorAll('[data-slide]'));
      this.querySelector('[data-prev]')?.addEventListener('click', () => this.step(-1));
      this.querySelector('[data-next]')?.addEventListener('click', () => this.step(1));
      this.mark = buildDots(this, this.slides.length, (i) => this.go(i));
      this.track.addEventListener('scroll', () => this.sync(), { passive: true });
      this.sync();
      if (this.dataset.autoscroll === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.timer = setInterval(() => {
          const max = this.track.scrollWidth - this.track.clientWidth;
          if (max <= 0) return;
          if (this.track.scrollLeft >= max - 4) this.track.scrollTo({ left: 0, behavior: 'smooth' });
          else this.step(1);
        }, 3500);
        ['pointerdown', 'wheel', 'touchstart'].forEach((ev) =>
          this.track.addEventListener(ev, () => clearInterval(this.timer), { once: true, passive: true })
        );
      }
    }
    disconnectedCallback() { clearInterval(this.timer); }
    slideWidth() {
      const first = this.slides[0];
      if (!first) return this.track.clientWidth;
      const gap = parseFloat(getComputedStyle(this.track).columnGap || '0') || 0;
      return first.getBoundingClientRect().width + gap;
    }
    step(dir) { this.track.scrollBy({ left: dir * this.slideWidth(), behavior: 'smooth' }); }
    go(i) { this.track.scrollTo({ left: i * this.slideWidth(), behavior: 'smooth' }); }
    sync() {
      const i = Math.round(this.track.scrollLeft / Math.max(1, this.slideWidth()));
      this.mark(Math.min(this.slides.length - 1, Math.max(0, i)));
    }
  }

  if (!customElements.get('pp-rotator')) customElements.define('pp-rotator', PPRotator);
  if (!customElements.get('pp-carousel')) customElements.define('pp-carousel', PPCarousel);
})();
